import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Globe2, Lock } from "lucide-react";
import SectionHeading from "../SectionHeading";
import { staggerVariants, VIEWPORT_ONCE } from "../../lib/motion";

const principles = [
    {
        icon: ShieldCheck,
        title: "Transparency by default",
        copy: "Real-time trade data, published execution policy, audit trails on every order.",
    },
    {
        icon: Lock,
        title: "Client funds, segregated",
        copy: "Customer money sits with tier-1 banking partners — never co-mingled with operational capital.",
    },
    {
        icon: Globe2,
        title: "Built for global traders",
        copy: "Servers across three continents, 24/5 support, settlement in 12 currencies.",
    },
];

const fadeUp = staggerVariants({ y: 20, duration: 0.5, step: 0.08 });

export default function AboutPrinciples() {
    return (
        <section className="py-24 lg:py-28 bg-[#0A0E23]/40 border-y border-white/5">
            <div className="xpo-container">
                <SectionHeading
                    overline="Principles"
                    title="Three things we will not compromise on."
                    align="center"
                />
                <div className="grid md:grid-cols-3 gap-6 mt-14">
                    {principles.map((p, i) => (
                        <motion.div
                            key={p.title}
                            variants={fadeUp}
                            initial="hidden"
                            whileInView="visible"
                            custom={i}
                            viewport={VIEWPORT_ONCE}
                            className="xpo-glass p-8"
                        >
                            <div className="w-12 h-12 rounded-xl bg-[#A6E3DC]/10 border border-[#A6E3DC]/20 grid place-items-center mb-5">
                                <p.icon size={22} className="text-[#A6E3DC]" />
                            </div>
                            <h3 className="text-xl font-bold text-white">
                                {p.title}
                            </h3>
                            <p className="text-slate-400 mt-3 leading-relaxed">
                                {p.copy}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
